module.exports = __webpack_public_path__ + "static/media/pay_cards.73364f64.svg";